import React from 'react';
import { Redirect } from 'react-router-dom';
import Auth from '../../services/api/Auth';
import { withRouter } from 'react-router-dom'


class LoggedAs extends React.Component {
    render() {
        return (
          <div className="logged_as">
          <small>Bejelentkezve: {localStorage.getItem('uid')}</small>
          </div>
        )
    }
}
export default LoggedAs;



// WEBPACK FOOTER //
// ./src/components/LoggedAs/index.js